<template>
    <div class="sc-cal">
        <div class="sc-cal-head">
            <span class="month">{{ year }}{{ $t("년") }} {{ month + 1 }}{{ $t("월") }}</span>
            <span class="nav">
                <button
                    type="button"
                    class="sc-btn sc-btn--sm sc-btn--icon"
                    :aria-label="$t('이전 달')"
                    @click="move(-1)"
                >
                    ‹
                </button>
                <button type="button" class="sc-btn sc-btn--sm" @click="goToday">{{ $t("오늘") }}</button>
                <button
                    type="button"
                    class="sc-btn sc-btn--sm sc-btn--icon"
                    :aria-label="$t('다음 달')"
                    @click="move(1)"
                >
                    ›
                </button>
            </span>
        </div>
        <div class="sc-cal-legend">
            <span><i class="off"></i>{{ $t("예외일") }}</span>
            <span><i class="today"></i>{{ $t("오늘") }}</span>
        </div>
        <div class="sc-cal-grid" role="grid">
            <div v-for="(label, i) in WEEK" :key="label" class="dow" :class="{ sun: i === 0, sat: i === 6 }">
                {{ label }}
            </div>
            <template v-for="(cell, i) in cells">
                <button
                    v-if="cell.date && editable"
                    :key="i"
                    type="button"
                    class="day is-button"
                    :class="cellClass(cell)"
                    :aria-label="cell.date"
                    @click="$emit('day-click', cell.date, exceptMap[cell.date] || null)"
                >
                    {{ cell.day }}
                </button>
                <div v-else :key="i" class="day" :class="cellClass(cell)">{{ cell.day }}</div>
            </template>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { activeExceptMap } from "../utils/scheduleFormat";

const WEEK = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: {
        exceptions: { type: Array, default: () => [] },
        editable: { type: Boolean, default: false },
    },
    data() {
        const now = moment();
        return { WEEK, year: now.year(), month: now.month() };
    },
    computed: {
        exceptMap() {
            return activeExceptMap(this.exceptions);
        },
        cells() {
            const first = moment({ year: this.year, month: this.month, day: 1 });
            const cells = Array.from({ length: first.day() }, () => ({ date: null, day: "" }));
            for (let d = 1; d <= first.daysInMonth(); d++) {
                cells.push({ date: first.clone().date(d).format("YYYY-MM-DD"), day: d });
            }
            return cells;
        },
        today() {
            return moment().format("YYYY-MM-DD");
        },
    },
    methods: {
        move(delta) {
            const next = moment({ year: this.year, month: this.month, day: 1 }).add(delta, "month");
            this.year = next.year();
            this.month = next.month();
        },
        goToday() {
            const now = moment();
            this.year = now.year();
            this.month = now.month();
        },
        cellClass(cell) {
            if (!cell.date) return "";
            return {
                "is-except": !!this.exceptMap[cell.date],
                "is-today": cell.date === this.today,
            };
        },
    },
};
</script>
